module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Hillary Davis, Steven Rothfeld\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Hillary Davis, ")]), _vm._v("food journalist, cooking instructor, and writer and creator of the popular food blog Marche Dimanche, is a long-time food columnist and restaurant critic for "), _c('I', [_vm._v("New Hampshire Magazine,")]), _vm._v(" and her work has been featured in many national and international magazine and website articles. She is also the author of "), _c('I', [_vm._v("Cuisine Niçoise")]), _vm._v(" and has been a food and travel lecturer on Royal Caribbean and Celebrity cruise lines. She lives in New Hampshire.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/kdjsWq/tc-custom/9781423643005.jpg?1736954284625",
      "alt": "This image is the cover for the book French Desserts"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("French Desserts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The author of "), _c('i', [_vm._v("French Comfort Food")]), _vm._v(" shares her love of sinfully sweet desserts with recipes drawn from across France’s regional culinary traditions.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In "), _c('i', [_vm._v("French Desserts")]), _vm._v(", Hillary Davis celebrates her favorite French sweets and treats, featuring specialties from Gascony, Alsace, the Ardennes, and beyond. Focusing on the homey comfort food that French people make in their own kitchens, the book includes both recipes for quick fixes and those with longer preparation times. You will find cakes, cookies, tarts, candies, verrines, puff pastries, waffles, crepes, and more."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Recipes include Giant Break-and-Share Cookie, Fresh Orange Crepes Suzette, Chocolate on Chocolate Tart with Raspberries, Chocolate Soufflé, Tart Lime and Yogurt Loaf Cake with Sugared Lime Drizzle, and Peach Melba with Muddled Vanilla Ice Cream.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0